import { InputButton, type PlayerInput } from "@arcade-hockey/shared";
import type { MatchState, PlayerState } from "@arcade-hockey/sim";
import { fillChase } from "../geometry/chase.js";

// 0.8 m matches tuning.puckStrip.stickLiftReach. Inside this, attempt to
// strip with a stick-lift — cheap, doesn't pop the puck halfway across
// the rink, no stun.
const STICK_LIFT_RANGE = 0.8;
const CHASE_DEADBAND = 0.5;
// Body-check engine fires at (sprint ≥ 0.5, dist ≤ 2*radius ≈ 1.3 m,
// closing speed > 1 m/s). To make the check a deliberate commit rather
// than an automatic byproduct of pursuit, we never sprint inside the
// engage zone unless the (in_our_half + coming_at_us) angle condition
// holds — same gate as before.
const ENGAGE_RANGE = 1.5;
// Outside the engage zone but within pursuit range, sprint to actually
// close the gap. Without this the defender chases at base speed (same
// as the carrier) and never catches up, so plays just drift forever.
const PURSUIT_SPRINT_RANGE = 6;

export function fillDefenderInput(
  input: PlayerInput,
  player: PlayerState,
  carrier: PlayerState,
  _state: MatchState,
): void {
  fillChase(input, player, carrier.pos.x, carrier.pos.y, CHASE_DEADBAND);
  const dx = carrier.pos.x - player.pos.x;
  const dy = carrier.pos.y - player.pos.y;
  const dist = Math.hypot(dx, dy);

  if (dist < STICK_LIFT_RANGE) {
    input.buttons |= InputButton.StickLift;
  }

  // Two sprint regimes:
  //   1. Pursuit: outside ENGAGE_RANGE but within PURSUIT_SPRINT_RANGE,
  //      sprint to actually close on the carrier. Body-check engine
  //      can't fire here (we're > ENGAGE_RANGE > 2*radius).
  //   2. Commit-to-check: inside ENGAGE_RANGE only when we have a
  //      defensive angle — carrier in our own half AND moving toward
  //      our net. This makes hits feel earned rather than automatic.
  if (dist >= ENGAGE_RANGE && dist < PURSUIT_SPRINT_RANGE) {
    input.sprint = 1;
  } else if (dist < ENGAGE_RANGE) {
    const defendDirX = player.teamId === "home" ? -1 : 1;
    const inOurHalf = player.teamId === "home" ? carrier.pos.x < 0 : carrier.pos.x > 0;
    const carrierComingAtUs = carrier.vel.x * defendDirX > 0;
    if (inOurHalf && carrierComingAtUs) {
      input.sprint = 1;
      input.buttons |= InputButton.BigHit;
    }
  }
}
